import { useState, useEffect } from "react";

const MLB_API = "https://statsapi.mlb.com/api/v1";

export const useMLBPlayerBio = (playerId) => {
  const [bio, setBio] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!playerId) {
      setBio(null);
      return;
    }
    setLoading(true);
    fetch(`${MLB_API}/people/${playerId}?hydrate=currentTeam`)
      .then((r) => r.json())
      .then((d) => {
        const person = d.people?.[0];
        if (person) {
          setBio({
            name: person.fullName,
            team: person.currentTeam?.abbreviation || "",
            position: person.primaryPosition?.abbreviation || "",
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [playerId]);

  return { bio, loading };
};
